import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { SubstanceDrugsSupplementalPublicSafetyItemModel } from '../types';

const substanceDrugsSupplementalPublicSafetyItemValidator: ValidateJSModel<SubstanceDrugsSupplementalPublicSafetyItemModel> = {
  DrugUsed: { presence: true, hasValue: true },
  DateRange: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
  }),
  NumberOfTimesUsed: { presence: true, hasValue: true },
  Comment: {}
};

export default substanceDrugsSupplementalPublicSafetyItemValidator;
